exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.toolbar_wrapper {\n  box-shadow: 2px 2px 3px;\n  padding-top: 3px;\n  padding-bottom: 5px;\n  background-color: #095b69;\n}\n", ""]);

// exports
